const InspectorFolders = () => import('../components/Inspector/Folders');
const InspectorList = () => import('../components/Inspector/List');
const InspectorTasks = () => import('../components/Inspector/Tasks');
const InspectorTaskView = () => import('../modules/Inspector/views/TaskView');
const InspectorWorkInstructionView = () =>
  import('../components/Inspector/WorkInstructions');

const inspectorRoutes = [
  {
    path: '/view/inspector',
    name: 'inspector-list',
    component: InspectorList,
    meta: { authRequired: true },
  },
  {
    path: '/view/inspector/:id',
    name: 'inspector-tasks',
    component: InspectorTasks,
    meta: { authRequired: true },
  },
  {
    path: '/view/inspector/:id/folder/:folderId',
    name: 'inspector-folders',
    component: InspectorFolders,
    meta: { authRequired: true },
  },
  {
    path: '/view/inspector/:id/wi/:packageId?',
    name: 'inspector-work-instructions',
    component: InspectorWorkInstructionView,
    meta: { authRequired: true },
  },
  {
    path: '/view/inspector/:id/:taskNumber',
    name: 'inspector-template',
    component: InspectorTaskView,
    meta: { authRequired: true, needsTaskLock: true },
  },
];

export default inspectorRoutes;
